module.exports = __webpack_public_path__ + "img/trade-direct-logo.5f9a779f.png";